
import React from "react";
import { Grid, Typography,Paper,Box } from "@mui/material";
import AddIcon from '@mui/icons-material/Add'; // Replace with your image component or icon


const NoResponse = ({val}) => {
  return (
    <>
                  
                  <Paper elevation={3} sx={{ padding: 3, backgroundColor: '#ffffff', borderRadius: 2,marginTop:"4px",marginBottom:"20px" }}>
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 3,
      border: '2px dashed #FF8C00',
      borderRadius: 2,
      minHeight: { xs: '200px', sm: '150px' },
      textAlign: 'center',
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Grid container alignItems="center" spacing={2}>
    <Grid
  item
  xs={12}
  sm={4}
  sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mb: { xs: 2, sm: 0 },
  }}
>
  <img 
    src="https://cdn.vectorstock.com/i/500p/04/11/no-data-empty-concept-vector-41830411.jpg" 
    alt="No Trade" 
    style={{
      width: '100%', // Makes the image responsive to container size
      maxWidth: '200px', // Maximum width of image (adjust as necessary)
      height: 'auto', // Maintains aspect ratio
    }} 
  />
</Grid>

<Grid item xs={12} sm={8}>
  <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#FF8C00' }}>
    No Projects Found!
  </Typography>
  <Typography
    variant="subtitle1"
    color="textSecondary"
    sx={{ mt: 1, maxWidth: '500px', mx: 'auto' }}
  >
    It looks like you haven't created any projects yet. To get started, click on <b style={{ color: '#FF8C00' }}>"Add"</b> and provide your project details and location to begin managing them efficiently.
  </Typography>
</Grid>

    </Grid>
  </Box>
</Paper>


  </>
  
  
  );
};

export default NoResponse;
